import { useDecision } from '@optimizely/react-sdk'

export function useIsWizard2DDBannerEnabled() {
  const [isWizard2DDEnabled] = useDecision('beetroots_ofx_wizard_2dd_banner')

  return isWizard2DDEnabled.variationKey === 't1'
}
